export default "__VITE_ASSET__CTFrD3MX__"